<div class="py-4 container-fluid subject-management-create-page">
  <h4 class="mb-4 subject-management-create-title">การจัดการรายวิชา</h4>

  <div class="subject-management-create-card">
    <div class="subject-management-create-card-body">
      <app-subject-info-form
        [subjectForm]="subjectForm"
        [isSaved]="isSaved"
        [subjectApprovalStatusLabel]="subjectApprovalStatusLabel"
        [subjectApprovalStatus]="subjectApprovalStatus"
        [academicTermOptions]="academicTermOptions"
        [yearOptions]="yearOptions"
        [subjectTypeOptions]="subjectTypeOptions"
        [subjectOptions]="subjectOptions"
        [curriculumTypeOptions]="curriculumTypeOptions"
        [submitted]="submitted"
        (requestSave)="onRequestSaveSubject()"
        (requestDelete)="onRequestDeleteSubject()"
      ></app-subject-info-form>

    </div>
  </div>
</div>

<app-confirm-dialog #saveSubjectConfirmDialog modalId="saveSubjectConfirmDialog" title="ยืนยันการสร้างรายวิชา"
  message="ระบบจะสร้างรายการรายวิชาแบบร่าง จากนั้นจึงเพิ่ม Section และผู้สอนในหน้ารายละเอียด"
  cancelText="ยกเลิก" icon="warning" confirmText="ยืนยัน" [isProcessing]="isSubmittingApproval"
  (confirmed)="onSaveSubject()"></app-confirm-dialog>

<app-confirm-dialog #saveSubjectErrorDialog modalId="saveSubjectErrorDialog" title="ไม่สามารถบันทึกข้อมูลได้"
  [message]="saveSubjectErrorMessage" icon="warning" confirmText="ปิด" [showCancelButton]="false"
  (confirmed)="saveSubjectErrorDialog.close()"></app-confirm-dialog>

<app-confirm-dialog #deleteSubjectConfirmDialog modalId="deleteSubjectConfirmDialog" title="ยืนยันการลบรายวิชา"
  message="คุณต้องการลบรายวิชานี้ใช่หรือไม่ ?" cancelText="ยกเลิก" confirmText="ยืนยัน"
  (confirmed)="onConfirmDeleteSubject()"></app-confirm-dialog>
